import { Select, Button, styled } from '@/theme/index';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: '290px',
  [theme.breakpoints.up('sm')]: {
    width: '170px',
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: '550px',
  },
}));

export const DropdownQuestion = {
  screenId: 'OWN-02-1-02',
  customAttribute: 'prop_search_reasons',
  answerSet: [
    'Check home value',
    'See other homes',
    'Look up deed data',
    'Find liens data',
    'Check information about homeowner',
    'Contact homeowner',
    'Just curious',
    'None of the above',
  ],
};
